import { createClient } from '@supabase/supabase-js';
const supabaseUrl = 'https://mdaiqzndypcnuphskzpc.supabase.co';
const supabaseKey =
	'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1kYWlxem5keXBjbnVwaHNrenBjIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTcwNzQxNDg0NywiZXhwIjoyMDIyOTkwODQ3fQ.L8CJo4TDAbkML6c0DoCjuE1PRq-HXnmmSMwG6ety2FY';

const supabase = createClient(supabaseUrl, supabaseKey);
export default supabase;
/*https://www.vecteezy.com/vector-art/11621940-quote-icon-vector-design-template logo link*/
